/* Vivid Ads — client gallery lightbox.
   Progressive enhancement: with this file blocked the grid still renders and
   every thumbnail is a real, focusable button; it simply does not zoom. */
(function () {
  'use strict';
  if (window.__vvGalleryBoot) return;
  window.__vvGalleryBoot = 1;

  function init() {
    var grid = document.querySelector('.vvg__grid');
    if (!grid || grid.__vvWired) return;
    grid.__vvWired = 1;

    var items = [].slice.call(grid.querySelectorAll('.vvg__item'));
    if (!items.length) return;
    var idx = 0, lastFocus = null;

    var lb = document.createElement('div');
    lb.className = 'vvg-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Customer photo viewer');
    lb.innerHTML =
      '<img class="vvg-lb__img" alt="">' +
      '<button type="button" class="vvg-lb__btn vvg-lb__close" aria-label="Close">✕</button>' +
      '<button type="button" class="vvg-lb__btn vvg-lb__prev" aria-label="Previous photo">‹</button>' +
      '<button type="button" class="vvg-lb__btn vvg-lb__next" aria-label="Next photo">›</button>' +
      '<p class="vvg-lb__count"></p>';
    document.body.appendChild(lb);

    var img   = lb.querySelector('.vvg-lb__img');
    var count = lb.querySelector('.vvg-lb__count');
    var btnClose = lb.querySelector('.vvg-lb__close');

    function show(i) {
      idx = (i + items.length) % items.length;
      var el = items[idx];
      img.src = el.getAttribute('data-full');
      img.alt = (el.querySelector('img') || {}).alt || '';
      count.textContent = (idx + 1) + ' of ' + items.length;
      // warm the neighbours so arrowing through feels instant
      [idx + 1, idx - 1].forEach(function (j) {
        var n = items[(j + items.length) % items.length];
        if (n) { var pre = new Image(); pre.src = n.getAttribute('data-full'); }
      });
    }

    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      btnClose.focus();
    }

    function close() {
      lb.hidden = true;
      img.removeAttribute('src');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    items.forEach(function (el, i) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(i); });
    });

    btnClose.addEventListener('click', close);
    lb.querySelector('.vvg-lb__prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.vvg-lb__next').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowRight') { show(idx + 1); }
      else if (e.key === 'ArrowLeft') { show(idx - 1); }
      else if (e.key === 'Tab') {
        // keep focus inside the dialog
        var f = [].slice.call(lb.querySelectorAll('button'));
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // swipe on touch
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) show(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setTimeout(init, 1500);
})();
